import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Router,NavigationStart, NavigationEnd  } from '@angular/router';
import { Helpers } from "./helpers";
import { AuthenticationService } from "./authentication.service"
import Swal from 'sweetalert2';
import {session} from '../environments/environment.session'
import {en} from '../environments/environment.tok'
import {SpinnerService} from './shared/spinner.service'
import {DecryptService} from "./decrypt.service";
import {NetworkService} from './network.service'
@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'app';
  erpUser:any=undefined

 constructor(private _router: Router, private AuthenticationService: AuthenticationService, private decrypt:DecryptService , private netConnection:NetworkService) {
    try {
		this.erpUser = JSON.parse(sessionStorage.getItem('1001') as any);
    } catch (err) {
      sessionStorage.clear();
      return;
    }

  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
		this.netConnection.network()
  }


  
  async ngOnInit() {
	Helpers.setLoading(false);
	await this.getserver();
	en.temppu=await this.decrypt.decryptUsingAES256(en.temppu)
	en.temppa=await this.decrypt.decryptUsingAES256(en.temppa)
	if(this.severListen) {
		this.gon=true
		this._router.navigate(['/error']);
		return;
	}
	
	  if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
		this.gon=true
	 	 this._router.navigate(['/login'])
	  }else{
		this.gon=false
			await this.getErpUser()
			
			// if (this.erpUser['b_acct_id'] == 0) {
			// 	this._router.navigate(['./solution-admin/index']);
			// } else {
			// 	// if (this.erpUser['role_cd'].includes('DIRECTOR') || this.erpUser['role_cd'].includes('Dir')  ) {
			// 	// 	this._router.navigate(['./file-o0verView']);  
			// 	//   }else{
			// 		console.log(this.erpUser)
			// 		console.log(session.erpUser)
			// 		let is_returned_from_payment_gateway = sessionStorage.getItem('1010');
			// 	if (is_returned_from_payment_gateway && !sessionStorage.getItem('reloaded')) {
			// 			sessionStorage.setItem('reloaded', 'true');
			// 			location.reload();  
			// 	} 

			// 	let is_returned_from_payment_gatway = sessionStorage.getItem('1010')
			// 	if(is_returned_from_payment_gatway  && !sessionStorage.getItem('reloaded')){
			// 		sessionStorage.setItem('reloaded', 'true');
			// 		location.reload();  
			// 	}else if(!is_returned_from_payment_gatway ){
			// 		// this._router.navigate(["/cfc/cfc-index"])
			// 	}


				
			// 	// else{
			// 	// 	sessionStorage.removeItem('1010')
			// 	// }
			// 	//   }
			// }
		}
		 
	this.getAllLabel();
    this.getSystemModule();
    this.getAllLanguage();
		this._router.events.subscribe((route:any) => {
			if (route instanceof NavigationStart) {
				Helpers.setLoading(true);
				Helpers.bodyClass('fixed-navbar');
			}
			if (route instanceof NavigationEnd) {
				window.scrollTo(0, 0);
				Helpers.setLoading(false);
				if(route.url=='/login' && sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null ){
					this._router.navigate(['/login']);
				}
				// Initialize page: handlers ...
				// Helpers.initPage();
			}

		});

		Helpers.setLoading(false);
		
	}


    gon:boolean=true
	async getErpUser(){
		let obj={}
		let resp=await this.AuthenticationService.getErpUser((obj))
		if(resp['error']==false){
			this.erpUser=JSON.parse(resp['data'][0]['erpUser'])
			session.erpUser=btoa(resp['data'][0]['erpUser'])
			this.gon=true
		}else{
			Swal.fire('Error',resp['data'],'error')
		}
	}

	

	allLanguage = []
	async getAllLanguage() {
		var obj = new Object();
		var resp = await this.AuthenticationService.getAllLanguages(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLanguage = resp.data;
			this.AuthenticationService.language_cd = resp.data[0]['language_cd']
		} else {

		}
	}

	async getSystemModule() {
		let obj:any = new Object();
		obj['b_acct_id'] = 0;
		var resp = await this.AuthenticationService.getModules(JSON.stringify(obj));
		if (resp['error'] == false) {
			  obj = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
			}
			this.AuthenticationService.allSystemModuleObj = obj;

		} else {

		}
	}
	severListen:any=false;
	async getserver() {
		var resp = await this.AuthenticationService.getserver(JSON.stringify({}));
		console.log(resp)
		if (resp['error'] ) {
			this.severListen=resp['error']
			this._router.navigate(['/error']);
		}  
	}


	allLabel = []
	async getAllLabel() {
		var obj:any = new Object();
		obj['module_cd']=["COMMON","MD"]
		var resp = await this.AuthenticationService.getcomponentLabelvalueswithLanguage(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLabel = resp.data;
		 let  obj:any = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['language_cd'] + resp.data[i]['component_cd'] + resp.data[i]['label_no']] = resp.data[i]['value_to_show'];
			}
			this.AuthenticationService.allLableShowObj = obj;

		} else {

		}
	}

	/********************************************** auto logout code start ************************************************ */
	@HostListener('document:mousemove', ['$event']) MouseMove() {this.resetTimer()}
	@HostListener('document:keypress', ['$event']) KeyBord() {this.resetTimer()}
	// @HostListener('window:beforeunload', ['$event']) windowBeforeUnload() {this.logOut()} 

	timer:any
	time_out_time = 30; // in minutes
	resetTimer() {
		clearTimeout(this.timer);
		this.timer = setTimeout(async () => {
			await this.logOut()
		}, this.time_out_time * 60 * 1000); // 30 minutes in milliseconds
	}

	async logOut() {
		if (window.location.hash != '#/login' && !this.AuthenticationService.uiHost.startsWith('localhost')) {
			Swal.fire('Opps..', 'Your session is expired please login again', 'info')
			sessionStorage.removeItem('1000')
			sessionStorage.removeItem('1001')
			session.erpUser={}
			this._router.navigate(['/login']);
		}
	}



	/********************************************** auto logout code end *****************************************************/
}
